import React from "react"
import { formatAsPrice, formatDateTime } from "../../../../utils/formatters"
import TwoRowsCell from "../../../common/cells/TwoRowsCell"
import TwoRowsHeaderCell from "../../../common/cells/TwoRowsHeaderCell"
import type { FiltersIdentifier } from "../../../filters/types"
import ReportDataTable from "../../../common/ReportDataTable"
import type { SpecialPricingLogReportItem } from "../../../../graphql/types"
import { Color } from "../../../../constants"

type Props = {
    data: SpecialPricingLogReportItem[]
    reportIdentifier: FiltersIdentifier
}

class SpecialPricingLogReportTable extends React.PureComponent<Props> {
    render() {
        const columns = [
            {
                title: "Time",
                dataIndex: "originTimestamp",
                key: "timestamp",
                width: "20%",
                render: (text, record: SpecialPricingLogReportItem) => {
                    if (record.id === "total") {
                        return (
                            <span>
                                <b>Total</b>
                            </span>
                        )
                    }

                    return (
                        <TwoRowsCell
                            value={formatDateTime(record.originTimestamp, "h:mm A")}
                            subValue={formatDateTime(record.originTimestamp, "M/D/YYYY")}
                        />
                    )
                },
                defaultSortOrder: "descend",
                sorter: (a: SpecialPricingLogReportItem, b: SpecialPricingLogReportItem) =>
                    // @ts-expect-error
                    new Date(a.originTimestamp) - new Date(b.originTimestamp),
            },
            {
                title: <TwoRowsHeaderCell value="Order #" subValue="Service" />,
                key: "orderNumber",
                width: "20%",
                render: (text, record: SpecialPricingLogReportItem) => {
                    if (record.id === "total") {
                        return null
                    }

                    return <TwoRowsCell value={record.orderNumber} subValue={record.terminalName} />
                },
            },
            {
                title: <TwoRowsHeaderCell value="Assignee" subValue="Admin" />,
                key: "assigneeName",
                width: "20%",
                render: (text, record: SpecialPricingLogReportItem) => {
                    if (record.id === "total") {
                        return null
                    }

                    return <TwoRowsCell value={record.assigneeName} subValue={record.adminName} />
                },
            },
            {
                title: <TwoRowsHeaderCell value="± Pricing" subValue="Type" />,
                key: "pricingName",
                width: "20%",
                render: (text, record: SpecialPricingLogReportItem) => {
                    if (record.id === "total") {
                        return null
                    }

                    return <TwoRowsCell value={record.pricingName} subValue={record.type} />
                },
            },
            {
                title: "Total",
                dataIndex: "result",
                width: "20%",
                align: "right",
                render: (text, record: SpecialPricingLogReportItem) => {
                    const value = formatAsPrice(record.total)

                    if (record.id === "total") {
                        return record.total >= 0 ? (
                            <span>
                                <b>{value}</b>
                            </span>
                        ) : (
                            <span
                                style={{
                                    color: Color.Red,
                                }}>
                                <b>{value}</b>
                            </span>
                        )
                    }

                    return record.total >= 0 ? (
                        value
                    ) : (
                        <span
                            style={{
                                color: Color.Red,
                            }}>
                            {value}
                        </span>
                    )
                },
            },
        ]
        return (
            <ReportDataTable
                reportIdentifier={this.props.reportIdentifier}
                columns={columns}
                dataSource={this.props.data}
                rowKey="id"
                pagination={false}
            />
        )
    }
}

export default SpecialPricingLogReportTable
